import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { auth as authApi, getToken, removeToken, getDeviceToken } from '../api';

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser]             = useState(null);
  const [loading, setLoading]       = useState(true);
  const [notification, setNotif]    = useState(null);
  const [activePage, setActivePage] = useState('home');

  useEffect(() => {
    const token = getToken();
    if (!token) { setLoading(false); return; }
    authApi.me()
      .then(u => setUser(u))
      .catch(() => removeToken())
      .finally(() => setLoading(false));
  }, []);

  const showNotif = useCallback((msg, tipo = 'success') => {
    setNotif({ msg, tipo });
    setTimeout(() => setNotif(null), 3500);
  }, []);

  const login = useCallback(async (email, password) => {
    const data = await authApi.login({ email, password });
    setUser(data);
    // Registra device token se non già salvato (per login silenzioso futuro)
    if (!getDeviceToken()) authApi.registerDevice().catch(() => {});
    return data;
  }, []);

  const logout = useCallback(() => {
    authApi.logout();
    setUser(null);
    setActivePage('home');
  }, []);

  const tryAutoLogin = useCallback(async () => {
    try {
      const u = await authApi.me();
      setUser(u);
      return u;
    } catch {
      removeToken();
      return null;
    }
  }, []);

  return (
    <AppContext.Provider value={{
      user, setUser, loading,
      login, logout, tryAutoLogin,
      notification, showNotif,
      activePage, setActivePage,
    }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
